import * as THREE from 'three';
import { Vehicle } from '../core/Vehicle';
import { ModelLoader } from '../utils/ModelLoader';

export class Tractor extends Vehicle {
  private model: THREE.Group | THREE.Object3D | null = null;

  constructor() {
    super();
    this.maxSpeed = 1.5;
    this.acceleration = 0.03;
    this.deceleration = 0.02;
    this.turnSpeed = 0.04;
    
    // Set initial position of the vehicle
    this.mesh.position.set(0, 2.2, 0);
  }

  public async createModel(): Promise<void> {
    try {
      // Tải texture trước
      const textureLoader = new THREE.TextureLoader();
      console.log('Loading tractor texture...');
      const texture = await new Promise<THREE.Texture>((resolve, reject) => {
        textureLoader.load(
          '/tractor3d/Tractor.jpg',
          (tex) => {
            console.log('Tractor texture loaded successfully');
            resolve(tex);
          },
          undefined,
          (error) => {
            console.error('Error loading texture:', error);
            reject(error);
          }
        );
      });

      // Tải mô hình FBX
      console.log('Loading tractor model...');
      this.model = await ModelLoader.loadModel('/tractor3d/Tractor.fbx');
      console.log('Tractor model loaded successfully');
      
      // Tạo material với texture
      const material = new THREE.MeshPhongMaterial({ 
        map: texture,
        shininess: 30
      });
      
      // Áp dụng material cho tất cả các phần của mô hình
      this.model.traverse((child) => {
        if (child instanceof THREE.Mesh) {
          child.material = material;
        }
      });
      
      // Điều chỉnh thuộc tính mô hình
      this.model.scale.set(0.05, 0.05, 0.05);
      this.model.rotation.y = 0; // Thay đổi từ Math.PI sang 0 để hướng về phía trước
      this.model.position.y = 1.8; // Điều chỉnh vị trí Y để nằm trên mặt đường
      
      // Thêm mô hình vào mesh
      this.mesh.add(this.model);
      
    } catch (error) {
      console.error('Error loading tractor model:', error);
      // Tạo mô hình đơn giản nếu tải thất bại
      const geometry = new THREE.BoxGeometry(2, 1, 3);
      const material = new THREE.MeshPhongMaterial({ color: 0x2e8b57 });
      const fallbackMesh = new THREE.Mesh(geometry, material);
      
      // Thêm bánh xe đơn giản
      const wheelGeometry = new THREE.CylinderGeometry(0.5, 0.5, 0.3, 16);
      const wheelMaterial = new THREE.MeshPhongMaterial({ color: 0x333333 });
      
      // Bánh xe trước bên trái
      const frontLeftWheel = new THREE.Mesh(wheelGeometry, wheelMaterial);
      frontLeftWheel.rotation.z = Math.PI / 2;
      frontLeftWheel.position.set(1, -0.5, 1);
      fallbackMesh.add(frontLeftWheel);
      
      // Bánh xe trước bên phải
      const frontRightWheel = new THREE.Mesh(wheelGeometry, wheelMaterial);
      frontRightWheel.rotation.z = Math.PI / 2;
      frontRightWheel.position.set(-1, -0.5, 1);
      fallbackMesh.add(frontRightWheel);
      
      // Bánh xe sau bên trái
      const rearLeftWheel = new THREE.Mesh(wheelGeometry, wheelMaterial);
      rearLeftWheel.rotation.z = Math.PI / 2;
      rearLeftWheel.position.set(1, -0.5, -1);
      fallbackMesh.add(rearLeftWheel);
      
      // Bánh xe sau bên phải
      const rearRightWheel = new THREE.Mesh(wheelGeometry, wheelMaterial);
      rearRightWheel.rotation.z = Math.PI / 2;
      rearRightWheel.position.set(-1, -0.5, -1);
      fallbackMesh.add(rearRightWheel);
      
      this.mesh.add(fallbackMesh);
    }
  }
}